module.exports = __webpack_public_path__ + "assets/5adb682bc73345d505cd599b8d3f5191.mp3";